export default class AnchoredScrollSection {

    constructor() {
        this.bindUIActions();
    }

    bindUIActions() {

        if($('.js-anchored-scroll-nav').length) {
            window.addEventListener('DOMContentLoaded', () => {

                const observer = new IntersectionObserver(entries => {
                    entries.forEach(entry => {
                        const id = entry.target.getAttribute('id');
                        if (entry.intersectionRatio > 0) {
                            $(`.js-anchored-scroll-nav li a[href="#${id}"]`).parent().addClass('active');
                        } else {
                            $(`.js-anchored-scroll-nav li a[href="#${id}"]`).parent().removeClass('active');
                        }
                    });
                });

                const navHeight = $('.js-anchored-scroll-nav').outerHeight();

                // Track all sections that have an `id` applied
                document.querySelectorAll('section[id]').forEach((section) => {
                    section.style.minHeight = navHeight+'px';
                    observer.observe(section);
                });

            });

            // Increase z-index of paragraphs when they are in view
            $(window).on('scroll', () => {
                const $navItem = $('.js-anchored-scroll-nav');
                const navScrollTop = $navItem.offset().top;
                const $blocks = $('.js-section-block');

                $blocks.each( (index, section) => {
                    const $this = $(section);
                    const sectionOffsetTop = $this.offset().top - 360;

                    if (sectionOffsetTop < navScrollTop || (sectionOffsetTop > navScrollTop && sectionOffsetTop < navScrollTop + $navItem.outerHeight())) {
                        $this.addClass('z-20');
                    } else {
                        $this.removeClass('z-20');
                    }

                });
            })
        }

    }

};

new AnchoredScrollSection();